// Module
var code = "<div class=\"ui-grid-cell-contents\" title=\"{{row.entity.Extended}}\">\n    <div ng-bind=\"row.entity.Extended | date:'shortDate'\" smart-truncate></div>\n</div>";
// Exports
module.exports = code;